import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-custom-tab-login',
  templateUrl: './custom-tab-login.component.html',
  styleUrls: ['./custom-tab-login.component.scss'],
  standalone: false
})
export class CustomTabLoginComponent implements OnInit {

  login = true;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    const params = this.router.url;
    params.indexOf('registro') !== -1 ? this.login = true : this.login = false;
  }

}
